import { NextPage } from 'next';
import React from 'react';

import HeadMeta from '@/components/static-pages/HeadMeta';
import RoadtripGuideDirectoryTemplate, {
  RoadtripGuideDirectoryPageData,
} from '@/components/templates/RoadtripGuideDirectoryTemplate';
import getPageData from '@/services/getPageData.js';

const RoadtripGuideDirectory: NextPage<RoadtripGuideDirectoryPageData> = props => {
  const { title, seo_description, canonical_url } = props.metadata;

  return (
    <React.Fragment>
      <HeadMeta
        title={title}
        description={seo_description}
        canonicalUrl={canonical_url}
        noindex={!!props.fallback}
      />
      <RoadtripGuideDirectoryTemplate {...props} />
    </React.Fragment>
  );
};

RoadtripGuideDirectory.getInitialProps = async ({ req, res, query }) => {
  const pageData = await getPageData({ req, res, query });

  return { ...pageData };
};

export default RoadtripGuideDirectory;
